import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import OutletHead from '../../../components/common/outlet-head';
import { db } from './../../../firebase';
import { useAuth } from '../../../context/AuthContext';
import DataTable from '../../../components/ledger/party-datatables';

function Ledger() {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  function getParties() {
    const q = query(collection(db, "Businesses", bid, "Parties"), orderBy('partyName', 'desc'));
    const subscribe = onSnapshot(q, (querySnapshot) => {
      const tempDoc = [];
      querySnapshot.forEach((doc) => {
        tempDoc.push({ id: doc.id, ...doc.data() });
      });
      setData(tempDoc);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => subscribe;
  }

  useEffect(() => {
    getParties();
  }, []);

  return (
    <section className='section'>
      <OutletHead
        left={
          <h5 className='mb-0 fw-600'>Ledger</h5>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="outline-primary"
              type="submit"
              className='py-2 px-4 btn-width'
            >
              <IoDocumentTextOutline size={18} />
              <span className='ps-2'>Export</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            <DataTable
              columns={["#", "Party Name", "Phone Number", "City & State", "Amount", "Status"]}
              data={data}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Ledger;
